// Sport emojis mapping
export const sportEmojis: Record<string, string> = { 
 // Racket Sports
  'Tennis': '🎾',
  'Padel': '🎾',
  'Badminton': '🏸',
  'Table Tennis': '🏓',
  'Squash': '🎾',
  'Pickleball': '🎾',
  'Racquetball': '🎾',
  

  // Ball Sports
  'Football': '⚽',
  'American Football': '🏈',
  'Basketball': '🏀',
  'Volleyball': '🏐',
  'Rugby': '🏉',
  'Cricket': '🏏',
  'Baseball': '⚾',
  'Curling': '🥌',
  'Hockey': '🏑',
  'Softball': '🥎',
  'Billiards': '🎱',
  'Pool': '🎱',
  'Bocce': '🎳',
  'Dodgeball': '🏐',
  'Floorball': '🏑',
  'Futsal': '⚽',
  'Handball': '🤾',
  'Handball (Beach)': '🤾',
  'Lacrosse': '🥍',
  'Netball': '🏐',
  'Petanque': '🎳',
  'Sepak Takraw': '🏐',
  'Speedball': '🏐',
  'Spikeball': '🏐',
  'Ultimate Frisbee': '🥏',
  '5-a-side football': '⚽',
  'Bowling': '🎳',
  
  // Individual Sports
  'Golf': '⛳',
  'Running': '🏃‍♂️',
  'Cycling': '🚴‍♂️',
  'Swimming': '🏊‍♂️',
  'Climbing': '🧗‍♂️',
  'Surfing': '🏄‍♂️',
  'Skiing': '⛷️',
  'Snowboarding': '🏂',
  'Trekking': '🥾',
  'Athletic': '🏃',
  'Athletics': '🏃',
  'Shooting': '🔫',
  'Archery': '🏹',
  'BMX': '🚴‍♂️',
  'Darts': '🎯',
  'Handcycling': '🚴‍♂️',
  'Indoor Climbing': '🧗‍♂️',
  'Orienteering': '🧭',
  'Parkour': '🤸‍♂️',
  'Quad Biking': '🏍️',
  'Roller Skating': '⛸️',
  'Skateboarding': '🛹',
  'Speed Walking': '🚶‍♂️',
  'Trail Biking': '🚴‍♂️',
  'Trail Running': '🏃‍♂️',
  'Triathlon': '🏊‍♂️',
  'Billiard': '🎱',
  'Snooker': '🎱',
  'Clay Pigeon Shooting': '🔫',
  
  // Combat Sports
  'Boxing': '🥊',
  'Martial Arts': '🥋',
  'Karate': '🥋',
  'Brazilian Jiu-Jitsu': '🥋',
  'Capoeira': '🥋',
  'Hapkido': '🥋',
  'Iaido': '🥋',
  'Judo': '🥋',
  'Jujitsu': '🥋',
  'Kendo': '🥋',
  'Kickboxing': '🥊',
  'Krav Maga': '🥋',
  'Kung Fu': '🥋',
  'Muay Thai': '🥊',
  'Sambo': '🥋',
  'Savate': '🥊',
  'Sumo Wrestling': '🤼‍♂️',
  'Systema': '🥋',
  'Wrestling': '🤼‍♂️',
  'Fencing': '🤺',
  'Mixed Martial Arts': '🥊',
  'Taekwondo': '🥋',
  'Aikido': '🥋',
  
  // Equestrian Sports
  'Horse Riding': '🐎',
  'Polo': '🏇',
  'Horse Racing': '🏇',
  'Equestrian': '🐎',
  'Dressage': '🐎',
  'Eventing': '🐎',
  'Show Jumping': '🐎',
  'Vaulting': '🐎',
  
  // Water Sports
  'Sailing': '⛵',
  'Wakeboarding': '🏄‍♂️',
  'Wakesurfing': '🏄‍♂️',
  'Sea Sports': '🛥️',
  'Aquatics': '🏊‍♂️',
  'yachting': '🛥️',
  'bowls': '🎳',
  'Bodyboarding': '🏄‍♂️',
  'Body Surfing': '🏄‍♂️',
  'Canoeing': '🛶',
  'Canoe Polo': '🛶',
  'Deep Sea Fishing': '🎣',
  'Fishing': '🎣',
  'Flyboarding': '🏄‍♂️',
  'Freediving': '🤿',
  'Hydrofoil Surfing': '🏄‍♂️',
  'Jet Skiing': '🛥️',
  'Kayaking': '🛶',
  'Kiteboarding': '🪁',
  'Stand-Up Paddleboarding (SUP)': '🏄‍♂️',
  'Kitesurfing': '🪁',
  'Kneeboarding': '🏄‍♂️',
  'Parasailing': '🪂',
  'Rowing': '🚣‍♂️',
  'Scuba Diving': '🤿',
  'Skimboarding': '🏄‍♂️',
  'Skurfing': '🏄‍♂️',
  'Snorkeling': '🤿',
  'Stand-Up Paddleboarding': '🏄‍♂️',
  'Underwater Hockey': '🏒',
  'Water Skiing': '🎿',
  'Water Polo': '🤽‍♂️',
  'Whitewater Rafting': '🚣‍♂️',
  'Windsurfing': '🏄‍♂️',
  
  // Fitness & Wellness
  'Fitness': '💪',
  'Weight Training': '🏋️‍♀️',
  'Gym': '🏋️‍♂️',
  'Yoga': '🧘‍♀️',
  'Pilates': '🧘‍♂️',
  'Meditation': '🧘',
  'Aerobics': '💃',
  'Zumba': '💃',
  'Training': '🎯',
  'Wellness': '🧘‍♀️',
  'Spa': '💆‍♂️',
  'Aerial Silks': '🤸‍♀️',
  'Aerial Yoga': '🧘‍♀️',
  'Aqua Aerobics': '🏊‍♀️',
  'Aqua Zumba': '🏊‍♀️',
  'Barre': '🩰',
  'Bodyweight Training': '💪',
  'Breathwork': '🧘',
  'Chair Yoga': '🧘‍♀️',
  'Cold Plunge Therapy': '🧊',
  'CrossFit': '🏋️‍♂️',
  'Cryotherapy': '🧊',
  'Dance': '💃',
  'Foam Rolling': '🧘‍♂️',
  'Functional Training': '💪',
  'High-Intensity Interval Training (HIIT)': '💪',
  'Hot Pilates': '🧘‍♀️',
  'Hot Yoga': '🧘‍♀️',
  'Infrared Sauna': '🧖‍♂️',
  'Mindfulness': '🧘',
  'Piloxing': '🥊',
  'Postnatal Fitness': '🤱',
  'Powerlifting': '🏋️‍♂️',
  'Rebounding': '🤸‍♀️',
  'Sound Bath': '🎵',
  'Spinning / Indoor Cycling': '🚴‍♂️',
  'Stretching': '🤸‍♀️',
  'Tai Chi': '🧘‍♂️',
  'TRX Training': '💪',
  'Sauna': '🧖‍♂️',

  // Winter Sports
  'Biathlon': '🎿',
  'Bobsledding': '🛷',
  'Cross-Country Skiing': '⛷️',
  'Heli-Skiing': '🚁',
  'Ice Climbing': '🧗‍♂️',
  'Ice Hockey': '🏒',
  'Ice Skating': '⛸️',
  'Skeleton': '🛷',
  'Snowmobiling': '🛷',
  'Snowshoeing': '🥾',
  'Speed Skating': '⛸️',
  'Ski Jumping': '🎿',

  // Motorsports
  'Car Racing': '🏎️',
  'Drifting': '🏎️',
  'Karting': '🏎️',
  'Motorcycle Racing': '🏍️',
  'Off-Road Driving': '🚙',
  'Motorcycling': '🏍️',
  'Rally Racing': '🏎️',
  'Drag Racing': '🏎️',
  'Formula Racing': '🏎️',
  'Go-Karting': '🏎️',
  'Motocross': '🏍️',
  'Off-Roading': '🚙',
  'Racing': '🏎️',

  // Cards & Board games
  'Chess': '♟️',
  'Checkers': '⚫',
  'Monopoly': '🎲',
  'Scrabble': '🔤',
  'Poker': '🃏',
  'Uno': '🎴',
  'Mahjong': '🀄',
  'Bridge': '🃏',
  'Settlers of Catan': '🎲',
  'Ticket to Ride': '🚂',
  'Carcassonne': '🏰',
  'Risk': '🎲',
  'Clue (Cluedo)': '🔍',
  'Backgammon': '🎲',
  'Pandemic': '🦠',
  'Codenames': '🕵️',
  'Dominion': '👑',
  'Splendor': '💎',
  'Azul': '🔷',
  'Hearts': '♥️',
  'Spades': '♠️',
  'Canasta': '🃏',
  'Euchre': '🃏',
  'Pinochle': '🃏'
};

// Sport categories
export const SPORT_CATEGORIES = {
  'Racket Sports': [
    'Tennis', 'Padel', 'Badminton', 'Table Tennis', 'Squash', 'Pickleball', 'Racquetball'
  ],
  'Ball Sports': [
    'American Football', 'Baseball', 'Basketball', 'Billiards', 'Bocce', 'Cricket', 'Dodgeball', 'Floorball',
    'Football', 'Futsal', 'Handball', 'Handball (Beach)', 'Hockey', 'Lacrosse', 'Netball', 'Petanque', 'Rugby',
    'Sepak Takraw', 'Softball', 'Speedball', 'Spikeball', 'Ultimate Frisbee', 'Volleyball', '5-a-side football', 'Bowling'
  ],
  'Water Sports': [
    'Swimming', 'Surfing', 'Sailing', 'Wakeboarding', 'Aquatics', 'Bodyboarding', 'Body Surfing', 'Canoeing',
    'Canoe Polo', 'Deep Sea Fishing', 'Fishing', 'Flyboarding', 'Freediving', 'Hydrofoil Surfing', 'Jet Skiing',
    'Kayaking', 'Kiteboarding', 'Stand-Up Paddleboarding (SUP)', 'Kitesurfing', 'Kneeboarding', 'Parasailing', 'Rowing',
    'Scuba Diving', 'Sea Sports', 'Skimboarding', 'Skurfing', 'Snorkeling', 'Stand-Up Paddleboarding', 'Underwater Hockey',
    'Wakesurfing', 'Water Skiing', 'Water Polo', 'Whitewater Rafting', 'Windsurfing'
  ],
  'Fitness & Wellness': [
    'Yoga', 'Pilates', 'Fitness', 'Running', 'Cycling', 'Aerial Silks', 'Aerial Yoga', 'Aerobics', 'Aqua Aerobics',
    'Aqua Zumba', 'Barre', 'Bodyweight Training', 'Breathwork', 'Chair Yoga', 'Cold Plunge Therapy', 'CrossFit',
    'Cryotherapy', 'Dance', 'Foam Rolling', 'Functional Training', 'Gym', 'High-Intensity Interval Training (HIIT)',
    'Hot Pilates', 'Hot Yoga', 'Infrared Sauna', 'Meditation', 'Mindfulness', 'Piloxing', 'Postnatal Fitness',
    'Powerlifting', 'Rebounding', 'Sound Bath', 'Spinning / Indoor Cycling', 'Stretching', 'Tai Chi', 'TRX Training',
    'Weight Training', 'Zumba', 'Sauna', 'Spa', 'Wellness'
  ],
  'Winter Sports': [
    'Skiing', 'Snowboarding', 'Biathlon', 'Bobsledding', 'Cross-Country Skiing', 'Curling', 'Heli-Skiing',
    'Ice Climbing', 'Ice Hockey', 'Ice Skating', 'Skeleton', 'Snowmobiling', 'Snowshoeing', 'Speed Skating', 'Ski Jumping'
  ],
  'Combat Sports': [
    'Boxing', 'Martial Arts', 'Karate', 'Taekwondo', 'Aikido', 'Brazilian Jiu-Jitsu', 'Capoeira', 'Hapkido', 'Iaido',
    'Judo', 'Jujitsu', 'Kendo', 'Kickboxing', 'Krav Maga', 'Kung Fu', 'Muay Thai', 'Sambo', 'Savate', 'Sumo Wrestling',
    'Systema', 'Wrestling', 'Fencing', 'Mixed Martial Arts'
  ],
  'Equestrian': [
    'Dressage', 'Equestrian', 'Eventing', 'Horse Racing', 'Horse Riding', 'Polo', 'Show Jumping', 'Vaulting'
  ],
  'Individual Sports': [
    'Archery', 'Athletics', 'BMX', 'Climbing', 'Cycling', 'Darts', 'Golf', 'Handcycling', 'Indoor Climbing',
    'Orienteering', 'Parkour', 'Quad Biking', 'Roller Skating', 'Running', 'Skateboarding', 'Speed Walking',
    'Trail Biking', 'Trail Running', 'Trekking', 'Triathlon', 'Billiard', 'Snooker', 'Clay Pigeon Shooting', 'Shooting'
  ],
  'Motorsports': [
    'Car Racing', 'Drifting', 'Karting', 'Motorcycle Racing', 'Off-Road Driving', 'Motorcycling', 'Rally Racing', 'Drag Racing',
    'Formula Racing', 'Go-Karting', 'Motocross', 'Off-Roading', 'Racing'
  ],
  'Cards & Board games': [
    'Chess', 'Checkers', 'Monopoly', 'Scrabble', 'Poker', 'Uno', 'Mahjong', 'Bridge', 'Settlers of Catan',
    'Ticket to Ride', 'Carcassonne', 'Risk', 'Clue (Cluedo)', 'Backgammon', 'Pandemic', 'Codenames',
    'Dominion', 'Splendor', 'Azul', 'Hearts', 'Spades', 'Canasta', 'Euchre', 'Pinochle'
  ]
} as const;

// API retry configuration
export const API_CONFIG = {
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
  NETWORK_TIMEOUT: 5000
} as const;